import React from "react"

import "./searchOptions.css"
let classnames = require("classnames")
class SearchOptions extends React.Component {
  render() {
    const { suggestions } = this.props
    return (
      <React.Fragment>
        {suggestions.length > 0 && (
          <React.Fragment>
            {suggestions.map(suggestion => {
              const className = classnames("suggestion-item", {
                "suggestion-item--active": suggestion.active
              })

              return (
                /* eslint-disable react/jsx-key */
                <div
                  {...this.props.getSuggestionItemProps(suggestion, {
                    className
                  })}
                >
                  <span className="option-main">
                    <i className="fal fa-map-marker-alt"></i>&nbsp;&nbsp;
                    {suggestion.formattedSuggestion.mainText}
                  </span>{" "}
                  <span className="option-second">{suggestion.formattedSuggestion.secondaryText}</span>
                </div>
              )
              /* eslint-enable react/jsx-key */
            })}
          </React.Fragment>
        )}
      </React.Fragment>
    )
  }
}

export default SearchOptions

SearchOptions.defaultProps = {
  isMobile: false,
  suggestions: {},
  getSuggestionItemProps: function() {}
}
